import { Injectable } from '@angular/core';
import { SyllabusQuery } from '@examdojo/category/v2';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { combineLatest, distinctUntilChanged, map, Observable } from 'rxjs';
import { AdminUserQuery } from '../admin-user.query';
import { ReviewPermissionsListViewData } from './review-permissions-list-view.model';

@Injectable()
export class ReviewPermissionsListViewService extends AbstractSimpleListViewService<ReviewPermissionsListViewData> {
  constructor(
    private readonly adminUserQuery: AdminUserQuery,
    private readonly syllabusQuery: SyllabusQuery,
  ) {
    super();
  }

  readonly data$: Observable<ReviewPermissionsListViewData[]> = combineLatest([
    this.adminUserQuery.selectActive().pipe(distinctUntilChanged((a, b) => a?.id === b?.id)),
    this.syllabusQuery.entities$,
  ]).pipe(
    map(([activeUser, allSyllabuses]) => {
      return allSyllabuses.map((syllabus) => {
        const assignedPermissions = activeUser?.assigned_syllabuses?.find(
          (binding) => binding.syllabus_id === syllabus.id,
        );

        return {
          id: `${activeUser?.id ?? 'no-user'}-${syllabus.id}`,
          syllabus: syllabus,
          permissions: assignedPermissions ?? null,
        } as ReviewPermissionsListViewData;
      });
    }),
  );

  readonly loading$: Observable<boolean> = combineLatest([
    this.adminUserQuery.selectLoading(),
    this.syllabusQuery.selectLoading(),
  ]).pipe(map((conditions) => conditions.some(Boolean)));
}
